import { createAction } from 'typesafe-actions';
import { ACTIONS } from './types';
import { IStatisticsItem } from 'widgets/Roulette/types';

export const setHotColdAnalytics = createAction(ACTIONS.SET_HOT_COLD_ANALYTICS)<
  IStatisticsItem[]
>();
